export default "__VITE_PUBLIC_ASSET__5a64ff07__"